var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"color":_vm.iconColor,"left":_vm.left,"right":_vm.right}},[_vm._v(_vm._s(_vm.iconValue))])
}
var staticRenderFns = []

export { render, staticRenderFns }